var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAutoReply = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12.034,
    viewBox: "0 0 16 12.034",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "label_FILL0_wght300_GRAD-25_opsz20",
    d: "M236.078-687.52l-4.243,5.213a2.3,2.3,0,0,1-.754.6,2.063,2.063,0,0,1-.917.208h-8.389a1.636,1.636,0,0,1-1.2-.5,1.636,1.636,0,0,1-.5-1.2v-8.637a1.636,1.636,0,0,1,.5-1.2,1.636,1.636,0,0,1,1.2-.5h8.393a1.946,1.946,0,0,1,.914.219,2.532,2.532,0,0,1,.753.607Zm-1.762,0-3.565-4.384a.706.706,0,0,0-.233-.2.628.628,0,0,0-.309-.081h-8.433a.331.331,0,0,0-.238.108.332.332,0,0,0-.108.238v8.637a.331.331,0,0,0,.108.238.331.331,0,0,0,.238.108h8.435a.627.627,0,0,0,.309-.081.706.706,0,0,0,.233-.2Zm-12.887,0v0Z",
    transform: "translate(-220.078 693.537)",
    fill: "#fff"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAutoReply, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/autoReply.df94d215.svg";
export { ForwardRef as ReactComponent };